module.exports = __webpack_public_path__ + "img/logo2.0fbe4de6.png";